export default {
    'contact.companyInfo.contactUs':"Зв'язатися з нами",
    'contact.companyInfo.h2.01':'Канцелярія Головного управління Шеньчженю',
    'contact.companyInfo.p.01':'промисловий парк лунхуа, Шеньчжень, провінції Гуандун',
    'contact.companyInfo.h2.02':'контактний телефон',
    'contact.companyInfo.p.02':'телефон: +86 18688782252, whatsApp,skype +86 18576744474',

    'contact.companyInfo.cardServer.h1':'робочий час',
    'contact.companyInfo.cardServer.p':'наше завдання - допомогти вам найкраще',
    'contact.companyInfo.cardServer.div1.span1':'з понеділка по суботу',
    'contact.companyInfo.cardServer.div1.span2':'8:00 ~ 22:00',
    'contact.companyInfo.cardServer.div2.span1':'спецодяг',
    'contact.companyInfo.cardServer.div2.span2':'7 * 24год',
    'contact.companyInfo.cardServer.div3.span1':'логістичні послуги',
    'contact.companyInfo.cardServer.div3.span2':'7 * 24год',


    'contact.form.h1':'залишити повідомлення',
    'contact.form.label.name':"ім'я",
    'contact.form.label.name.placeholder':"Введіть ім'я",
    'contact.form.label.type':'тип запиту',
    'contact.form.label.type.placeholder':'введіть тип запиту',
    'contact.form.label.type.option.01':'Product Enquiry / Quotation',
    'contact.form.label.type.option.02':'Logistic Quotation',
    'contact.form.label.type.option.03':'Logistic Enquiry',
    'contact.form.label.type.option.04':'Customer Service',
    'contact.form.label.type.option.other':'Others',
    'contact.form.label.email':'Email',
    'contact.form.label.email.placeholder':'введіть вашу поштову скриньку',
    'contact.form.label.phone':"зв'язок",
    'contact.form.label.phone.placeholder':'ведіть ваш номер телефону/WhatsAPP/Skype',
    'contact.form.label.content':'залишити повідомлення',
    'contact.form.label.content.placeholder':'Будь ласка, введіть своє повідомлення',
    'content.form.submit':'Передати'
}